/**
 * Extracted from `components/utility-bar-page-chrome.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

export function deriveBackFromBreadcrumbs(
  breadcrumbs:
    | ReadonlyArray<{ label: string; href?: string }>
    | undefined,
): { href: string; label: string } | null {
  if (!breadcrumbs?.length) return null
  for (let i = breadcrumbs.length - 1; i >= 0; i -= 1) {
    const crumb = breadcrumbs[i]
    if (crumb?.href) return { href: crumb.href, label: crumb.label }
  }
  return null
}
